import React from 'react';
import { useMutation } from 'react-fetching-library';
import { getOrderPrice } from '../../services/request';

export default function OrderCalculator({ field, formik, requestMethod }) {
  const [value, setValue] = React.useState('');
  const { mutate } = useMutation(requestMethod);
  const dependsOn = field.depends_on.trim().replaceAll('\n', '')
    .split(' ');

  React.useEffect(async () => {
    const { error, payload } = await mutate(formik.values);

    if (!error) {
      setValue(payload.text);
    } else {
      setValue('');
    }
  }, dependsOn.map(value => formik.values[value]));

  return <div dangerouslySetInnerHTML={{ __html: value }} style={{ marginTop: '20px', color: '#2A88C1' }}></div>;
};
